import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import ServiceGuidance from "components/ServiceGuidance";
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";

import bgFront3 from "assets/images/servicii/bgFront3.webp";
import bgBack3 from "assets/images/servicii/bgBack3.webp";

const advantages = {
    paragraphs: [
        "Oferim aceste servicii profesionale cu agenți calificați și experimentați, eficienți atât pentru suprafețele interioare, în curățarea ferestrelor sau a suprafețelor vitrate de compartimentare a birourilor, cât și pentru spălarea fațadelor exterioare.",
        "Pentru lucrări de întreținere a fațadelor, curățarea se poate realiza atât prin periere cu osmoză inversă, cât și cu drone cu jet de apă, în funcție de caz.",
    ],
};

const advice = {
    paragraphs: [
        "Apelați doar la firme de curățenie specializate, care pot garanta calitatea serviciilor. Atât sticla, cât și tâmplăria sunt suprafețe sensibile și se pot zgâria ușor; lipsa experienței poate duce la deteriorări iremediabile.",
        "Murdăria și depunerile de pe sticlă și tâmplărie trebuie îndepărtate doar cu ustensile și echipamente profesionale. Nu permiteți utilizarea bureților de vase, dispozitivelor abrazive, spatulelor sau altor instrumente contondente.",
        "Dacă pe profilul tâmplăriei sau pe sticlă există depuneri rămase în urma lucrărilor de construcție, solicitați efectuarea unei probe de curățare în fața dumneavoastră și verificați că nu apar deteriorări.",
        "Soluțiile acide (detartranții) pot ataca sticla și pot deteriora sistemele de închidere și etanșare; utilizarea necorespunzătoare poate compromite funcționarea sistemului în timp.",
    ],
};

function InformationHome() {
    return (
        <MKBox component="section" py={6} my={6}>
            <Container>
                <Grid container spacing={4} alignItems="stretch">
                    <Grid item xs={12} lg={4}>
                        <RotatingCard>
                            <RotatingCardFront image={bgFront3} icon="touch_app" title="Suprafețe vitrate" description="Metode adaptate sticlei, tâmplăriei și tipului de depuneri." />
                            <RotatingCardBack image={bgBack3} title="Lucru sigur" description="Solicită o evaluare gratuită." action={{ type: "internal", route: "/contact-curatenie", label: "cere o ofertă" }} />
                        </RotatingCard>
                    </Grid>
                    <Grid item xs={12} lg={8}>
                        <ServiceGuidance advantages={advantages} advice={advice} />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default InformationHome;
